import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en_translation from "./en.json";
import fr_translation from "./fr.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en_translation,
    },
    fr: {
      translation: fr_translation,
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
